<template>
  <div class="messages">
    <div class="messages_block">
      <div class="messages_list">
        <div v-for="message in messages" :key="message.id"
             v-bind:class="{'single_message': true, 'my_message': +message.user_id === $currentUID }">
          <div class="author">
            <template v-if="hideNames">
              <span v-if="+message.user_id !== $currentUID">Менеджер</span>
            </template>
            <template v-else>
              <template v-if="+message.user_id !== $currentUID">
                <template v-if="message.user">{{ message.user.name }}</template>
                <template v-else>
                  <UserName :id="+message.user_id"/>
                </template>
              </template>
            </template>
            <span
              class="text-muted message_date">{{ printDate(message.created_at, 'DD.MM HH:mm') }}</span></div>
          <div class="triangle"></div>
          <div class="message">
            <div class="body" v-html="message.message"/>
            <span class="read_marker" v-if="isReadMessage(message)">
              {{ printDate(message.acknowledge_by[0].date, 'DD.MM HH:mm', false, 0) }} <i class="icon-fa icon-fa-check"></i>
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="post_message">
      <template v-if="!dialogAccepted">
        <LoadingButton
          title="Принять запрос"
          :loading="loading"
          :color="$constants.SUCCESS_COLOR"
          :onClick="() => acceptDialog()"
          className="btn btn-outline-success br-0 w-100"
        />
      </template>
      <template v-else>
        <form @submit.prevent="sendMessage">
          <div class="input-group">
            <input type="text" :disabled="loading" v-model="message" required class="form-control br-0"
                   placeholder="Сообщение">
            <div class="input-group-append">
              <LoadingButton
                title="Отправить"
                type="submit"
                :loading="loading"
                :color="$constants.LOADING_COLOR"
                :onClick="() => {}"
                className="btn btn-outline-info br-0"
              />
            </div>
          </div>
        </form>
      </template>
    </div>
  </div>
</template>

<script>

import api from '@/api'
import LoadingButton from "@/components/buttons/LoadingButton";
import UserName from "@/components/users/UserName";

export default {
  props: ['messages', 'acceptTask', 'hideNames', 'updateDialog', 'dialogId', 'users', 'updateChatMessages', 'dialogAccepted', 'allowToClose'],
  components: {
    LoadingButton,
    UserName,
  },
  data() {
    return {
      loading: false,
      message: null,
      timeout: null,
      dialogUsers: {},
    }
  },
  mounted() {
    this.scrollBottom();
    this.checkUnReadMessages();
  },
  watch: {
    'messages': {
      handler: function (val, oldVal) {
        this.scrollBottom();
        this.checkUnReadMessages();
      },
    },
  },
  methods: {
    checkUnReadMessages() {
      if (this.timeout) {
        clearTimeout(this.timeout);
      }
      this.timeout = setTimeout(() => {
        this.makeMessageRead();
      }, 2000);
    },
    isReadMessage(message) {
      if (message.user_id !== this.$currentUID) return false;
      if (message.acknowledge_by && message.acknowledge_by.length) return true;
      return false;
    },
    async makeMessageRead() {
      const messages = this.messages.filter((m) => +m.user_id !== this.$currentUID && !((m.acknowledge_by || []).find((a) => +a.user_id === this.$currentUID)));
      if (messages && messages.length) {
        const {data} = await api.post('/new/chat/update', {
          type: 'readMessages',
          dialog_id: this.dialogId,
          messages
        })
      }
    },
    async acceptDialog(close = false) {
      this.loading = true;
      const {data} = await api.post('/new/chat/update', {
        type: close ? 'closeDialog' : 'acceptDialog',
        dialog_id: this.dialogId,
      })
      if (!data.success) {
        toastr['warning'](data.message || 'Ошибка');
      } else {
        if (this.acceptTask) {
          this.acceptTask();
        }
        if (this.updateDialog) {
          this.updateDialog({is_accepted: true});
        }
      }
      this.loading = false;
    },
    scrollBottom() {
      setTimeout(() => {
        const div = document.getElementsByClassName('messages_block')[0]
        div.scrollTop = div.scrollHeight;
      }, 100)
    },
    async sendMessage(e) {
      this.loading = true;
      const {data} = await api.post('/new/chat/update', {
        type: 'newMessage',
        dialog_id: this.dialogId,
        message: this.message
      })
      if (!data.success) {
        toastr['warning'](data.message || 'Ошибка');
      } else {
        if (this.updateDialog) {
          this.messages.push({message: this.message, user_id: this.$currentUID});
          this.updateDialog({messages: [...this.messages]})
        }
        this.message = null;
      }
      this.loading = false;
    }
  }
}

</script>

<style scoped>
.messages_block {
  height: calc(100% - 85px);
  border: 1px solid lightgray;
  border-bottom: none;
  padding: 10px;
  overflow: auto;
  background-color: white;
}

.post_message {
  height: 38px;
}

.br-0 {
  border-radius: 0;
}

.messages {
  height: 400px;
  /*min-height: 500px;*/
  /*overflow: auto;*/
  /*border: 1px solid lightgray;*/
}

.messages_list {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  min-height: 100%;
}

*:focus {
  border-color: inherit !important;
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
}

.triangle {
  border-color: transparent transparent #def1f8 transparent;
  margin-left: 15px;
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 0 10px 10px 10px;
}

.message .body {
  white-space: pre-line;
}

.message {
  background-color: #def1f8;
  padding: 10px;
  /*color: #fff;*/
  line-height: 25px;
  max-width: 90%;
  min-width: 50px;
  display: inline-block;
  text-align: left;
  border-radius: 5px;
}

.single_message {
  margin-bottom: 3px;
  max-width: 80%;
}

.single_message.my_message {
  align-self: self-end;
  text-align: right;
  position: relative;
  margin-right: 14px;
  width: 80%;
}

.single_message.my_message .message {
  margin-right: 15px;
  padding-bottom: 17px;
  min-width: 100px;
}

.read_marker {
  position: absolute;
  bottom: -3px;
  right: 19px;
  font-size: 14px;
  color: green;
  opacity: .4;
}

.my_message .triangle {
  position: absolute;
  right: 0;
  top: 40px;
  transform: rotate(90deg);
}

.message_date {
  font-size: 11px;
}

</style>
